export const FETCH_NEWSLETTER_REQUEST = 'newsletter/FETCH_NEWSLETTER_REQUEST';
export const FETCH_NEWSLETTER_SUCCESS = 'newsletter/FETCH_NEWSLETTER_SUCCESS';
export const FETCH_NEWSLETTER_FAILURE = 'newsletter/FETCH_NEWSLETTER_FAILURE';

export const FETCH_SURVEY_REQUEST = 'newsletter/FETCH_SURVEY_REQUEST';
export const FETCH_SURVEY_SUCCESS = 'newsletter/FETCH_SURVEY_SUCCESS';
export const FETCH_SURVEY_FAILURE = 'newsletter/FETCH_SURVEY_FAILURE';

export const FETCH_STATS_REQUEST = 'newsletter/FETCH_STATS_REQUEST';
export const FETCH_STATS_SUCCESS = 'newsletter/FETCH_STATS_SUCCESS';
export const FETCH_STATS_FAILURE = 'newsletter/FETCH_STATS_FAILURE';

export const FETCH_INDIVIDUALS_REQUEST = 'newsletter/FETCH_INDIVIDUALS_REQUEST';
export const FETCH_INDIVIDUALS_SUCCESS = 'newsletter/FETCH_INDIVIDUALS_SUCCESS';
export const FETCH_INDIVIDUALS_FAILURE = 'newsletter/FETCH_INDIVIDUALS_FAILURE';

export const SWITCH_ACTIVE_STATUS_REQUEST = 'newsletter/SWITCH_ACTIVE_STATUS_REQUEST';
export const SWITCH_ACTIVE_STATUS_SUCCESS = 'newsletter/SWITCH_ACTIVE_STATUS_SUCCESS';
export const SWITCH_ACTIVE_STATUS_FAILURE = 'newsletter/SWITCH_ACTIVE_STATUS_FAILURE';

export const UPDATE_QUESTION_TITLE_REQUEST = 'newsletter/UPDATE_QUESTION_TITLE_REQUEST';
export const UPDATE_QUESTION_TITLE_SUCCESS = 'newsletter/UPDATE_QUESTION_TITLE_SUCCESS';
export const UPDATE_QUESTION_TITLE_FAILURE = 'newsletter/UPDATE_QUESTION_TITLE_FAILURE';

export const DELETE_INDIVIDUAL_RESPONSE_REQUEST = 'newsletter/DELETE_INDIVIDUAL_RESPONSE_REQUEST';
export const DELETE_INDIVIDUAL_RESPONSE_SUCCESS = 'newsletter/DELETE_INDIVIDUAL_RESPONSE_SUCCESS';
export const DELETE_INDIVIDUAL_RESPONSE_FAILURE = 'newsletter/DELETE_INDIVIDUAL_RESPONSE_FAILURE';

export const INIT_REDUX_NEWLETTER = 'newsletter/INIT_REDUX_NEWLETTER';

export const INIT_STATS = 'newsletter/INIT_STATS';

export const INIT_INDIVIDUALS = 'newsletter/INIT_INDIVIDUALS';

export const INIT_QUESTION_UPDATE = 'newsletter/INIT_QUESTION_UPDATE';

export const INIT_RESPONSE_DELETED = 'newsletter/INIT_RESPONSE_DELETED';

export const fetchNewsletterRequest = (payload = {}) => ({
  type: FETCH_NEWSLETTER_REQUEST,
  payload,
});
export const fetchNewsletterSuccess = (payload = {}) => ({
  type: FETCH_NEWSLETTER_SUCCESS,
  payload,
});
export const fetchNewsletterFailure = (payload = {}) => ({
  type: FETCH_NEWSLETTER_FAILURE,
  payload,
});

export const fetchSurveyRequest = (payload = {}) => ({
  type: FETCH_SURVEY_REQUEST,
  payload,
});
export const fetchSurveySuccess = (payload = {}) => ({
  type: FETCH_SURVEY_SUCCESS,
  payload,
});
export const fetchSurveyFailure = (payload = {}) => ({
  type: FETCH_SURVEY_FAILURE,
  payload,
});

export const fetchStatsRequest = (payload = {}) => ({
  type: FETCH_STATS_REQUEST,
  payload,
});
export const fetchStatsSuccess = (payload = {}) => ({
  type: FETCH_STATS_SUCCESS,
  payload,
});
export const fetchStatsFailure = (payload = {}) => ({
  type: FETCH_STATS_FAILURE,
  payload,
});

export const fetchIndividualsRequest = (payload = {}) => ({
  type: FETCH_INDIVIDUALS_REQUEST,
  payload,
});
export const fetchIndividualsSuccess = (payload = {}) => ({
  type: FETCH_INDIVIDUALS_SUCCESS,
  payload,
});
export const fetchIndividualsFailure = (payload = {}) => ({
  type: FETCH_INDIVIDUALS_FAILURE,
  payload,
});

export const switchActiveStatusRequest = (payload = {}) => ({
  type: SWITCH_ACTIVE_STATUS_REQUEST,
  payload,
});
export const switchActiveStatusSuccess = (payload = {}) => ({
  type: SWITCH_ACTIVE_STATUS_SUCCESS,
  payload,
});
export const switchActiveStatusFailure = (payload = {}) => ({
  type: SWITCH_ACTIVE_STATUS_FAILURE,
  payload,
});

export const updateQuestionTitleRequest = (payload = {}) => ({
  type: UPDATE_QUESTION_TITLE_REQUEST,
  payload,
});
export const updateQuestionTitleSuccess = (payload = {}) => ({
  type: UPDATE_QUESTION_TITLE_SUCCESS,
  payload,
});
export const updateQuestionTitleFailure = (payload = {}) => ({
  type: UPDATE_QUESTION_TITLE_FAILURE,
  payload,
});

export const deleteIndividualResponseRequest = (payload = {}) => ({
  type: DELETE_INDIVIDUAL_RESPONSE_REQUEST,
  payload,
});
export const deleteIndividualResponseSuccess = (payload = {}) => ({
  type: DELETE_INDIVIDUAL_RESPONSE_SUCCESS,
  payload,
});
export const deleteIndividualResponseFailure = (payload = {}) => ({
  type: DELETE_INDIVIDUAL_RESPONSE_FAILURE,
  payload,
});

export const initReduxNewsletter = () => ({
  type: INIT_REDUX_NEWLETTER,
});

export const initStats = () => ({
  type: INIT_STATS,
});

export const initIndividuals = () => ({
  type: INIT_INDIVIDUALS,
});

export const initQuestionUpdate = () => ({
  type: INIT_QUESTION_UPDATE,
});

export const initResponseDeleted = () => ({
  type: INIT_RESPONSE_DELETED,
});
